<template>
  <VanPopup
    v-model:show="store.showPlayerEditModal"
    closeable
    class="max-h-[90%] min-h-[50%]"
    position="bottom"
    round
  >
    <div class="flex flex-col gap-4 px-5 py-4">
      <div class="text-base text-center font-bold">
        {{ $t("game.base.player") }}
      </div>
      <div class="flex flex-col gap-2">
        <div class="flex flex-col gap-2">
          <span>{{ $t("game.base.playerName") }}</span>
          <input v-model="activeName" class="input input-bordered" />
        </div>

        <div class="flex flex-col gap-2 mt-2">
          <span>{{ $t("game.base.playerAvatar") }}</span>
          <div
            class="flex justify-center"
            @click="store.showImgUploadModal = true"
          >
            <VanImage
              v-if="activeImg"
              class="w-40 rounded overflow-hidden min-h-[213px]"
              :src="activeImg?.url"
              fit="cover"
            />
            <i
              v-else
              class="iconfont icon-a- input input-bordered w-40 text-center leading-[213px] h-[213px]"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col items-center gap-2 mt-4">
      <button class="btn btn-sm btn-primary w-[200px]" @click="clickSave">
        <i class="iconfont icon-user-edit"></i>
        {{ $t("Buttons.save") }}
      </button>
      <button
        class="btn btn-sm w-[200px]"
        @click="store.showPlayerEditModal = false"
      >
        {{ $t("Buttons.back") }}
      </button>
    </div>
  </VanPopup>
</template>

<script setup lang="ts">
import { useGalGameEditor } from "@/stores/galGameEditor";
import { useStoryBook } from "@/stores/story-book";
import { watch, ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const storyBookStore = useStoryBook();
const store = useGalGameEditor();
const activeName = ref("");
const activeImg = ref<any>(null);

const clickSave = async () => {
  store.form.player.name = activeName.value;
  store.form.player.avatarMediaId = activeImg.value?.id;
  store.form.player.avatarMedia = activeImg.value;
  Object.values(store.characterIdMap).forEach((v) => {
    if (v.role === 3) {
      v.name = activeName.value;
      v.avatarMedia = activeImg.value;
    }
  });

  store.showPlayerEditModal = false;
  store.saveBase();
};

watch(
  () => store.showPlayerEditModal,
  (val) => {
    if (val) {
      if (store.form.player.name) activeName.value = store.form.player.name;
      if (store.form.player.avatarMediaId)
        activeImg.value = store.form.player.avatarMedia;
    }
  }
);

watch(
  () => store.tmpMedia,
  (val) => {
    if (store.uploadType === 0) activeImg.value = store.tmpMedia;
  },
  {
    deep: true,
  }
);

onMounted(() => {
  storyBookStore.role.tabType = 0;
});
</script>
